import { useEffect, useRef } from "react"
import io from "socket.io-client"
import { useStore } from "../store"
// import { usePOIStore } from "./activePOIStore"

const ActiveFloorBroadcaster = () => {
  const socket = useRef()
  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  const activeFloor = useStore(state => state.activeFloor)
  const setActiveFloors = useStore(state => state.setActiveFloors)

  const state = { activeFloor: activeFloor }

  useEffect(() => {
    socket.current = io(url)
    socket.current.emit("subscribe-actvfloorzustand", 1000)
    if (role === "recipient") {
      socket.current.on("actvfloorzustand", zustand => {
        setActiveFloors(zustand.activeFloor)
      })
    }
    return () => socket.current.close()
  }, [state, role, url])

  useEffect(() => {
    if (role === "sender") {
      socket.current.emit("actvfloorzustand", state)
    }
  }, [state, role, url])

  return null
}

ActiveFloorBroadcaster.propTypes = {}

export default ActiveFloorBroadcaster
